import { useState } from "react";

import { Box, Button, IconButton } from "@mui/material";
import docIconFileJpg from "assets/images/docIcon.jpg";
import fileIconUrl from "assets/images/fileIcon.png";
import FormControlLabel from "components/FormControlLabel";
import { TextFieldHookFormProps } from "components/TextField";
import { base, gray, primary } from "configs/colors";
import { shadows } from "configs/shadows";
import { useFileStorageControllerUploadFile } from "generated";
import { FileUploader } from "react-drag-drop-files";
import {
  Controller,
  FieldPath,
  FieldValues,
  get,
  useFormContext,
} from "react-hook-form";

import { EyeIcon, Trash03Icon, UploadCloud02Icon } from "../Icon";
import Typography from "../Typography";

interface Props {
  onChange: (...event: any[]) => void;
  value:
    | {
        newFileName: string;
        originalName: string;
        url: string;
        size: string;
        extname: string;
      }
    | undefined;
  disable: boolean | undefined;
  fileType: any;
  isViewForm?: boolean;
}

const Control = (props: Props) => {
  const { onChange, value, disable, fileType, isViewForm } = props;
  const [isImage, setIsImage] = useState<boolean>(true);
  // eslint-disable-next-line
  const { mutate } = useFileStorageControllerUploadFile({
    mutation: {
      onSuccess(data: any) {
        const dataResult: any = data?.data;
        onChange(dataResult);
      },
    },
  });
  const handleUploadFile = (event: File) => {
    const file = event || null;
    if (file) {
      // eslint-disable-next-line
      mutate(
        {
          data: {
            file,
          },
        },
        {
          onSuccess() {
            event /* .target.value */ = {} as any;
          },
        }
      );
    }
  };
  const handleNameFile = (fileName: string) => {
    const maxLength = 15;
    const extension = fileName.substring(fileName.lastIndexOf(".")); // Lấy đuôi file

    let shortenedFileName = fileName.substring(0, maxLength);

    if (shortenedFileName.length < fileName.length) {
      shortenedFileName += "...";
    }
    return shortenedFileName + extension;
  };
  const handleShowIcon = (extendName: string, url: string) => {
    if (extendName === ".pdf") {
      return fileIconUrl;
    }
    if (extendName === ".docx" || extendName === ".doc") {
      return docIconFileJpg;
    }
    return url;
  };
  return (
    <>
      {value ? (
        <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            height: "88px",
            padding: "14px",
            border: "1px",
            borderStyle: "solid",
            borderRadius: "12px",
            borderColor: gray[300],
            marginBottom: "24px",
          }}
        >
          <Box
            component="img"
            sx={{
              height: 40,
              width: 40,
              marginRight: "24px",
            }}
            alt={value?.originalName}
            src={handleShowIcon(value?.extname, value?.url)}
            onError={() => {
              setIsImage(false);
            }}
          />
          <Box
            sx={{
              flexGrow: 1,
            }}
          >
            <Typography type="TextSM" fontWeight={500} flex={1} align="left">
              {handleNameFile(value?.originalName)}
            </Typography>
            <Typography type="TextSM" color={gray[600]} flex={1} align="left">
              {`${Math.floor(Number(value?.size) / 1024)} KB`}
            </Typography>
            <Box display="flex">
              <Box display="flex" alignItems="center" paddingRight="8px">
                <IconButton
                  size="small"
                  onClick={() => {
                    window.open(value?.url);
                  }}
                >
                  <EyeIcon fontSize="small" color="primary" />
                </IconButton>
                <Typography type="TextSM">View</Typography>
              </Box>
              {/* <Box display="flex" alignItems="center" paddingRight="8px">
                <IconButton
                  size="small"
                  onClick={() => {
                    // console.log(value, "value");
                    // handleDownload(value?.url);
                  }}
                >
                  <DownloadCloud01Icon fontSize="small" color="primary" />
                </IconButton>
                <Typography type="TextSM">Download</Typography>
              </Box> */}
              {!isViewForm ? (
                <Box display="flex" alignItems="center" paddingRight="8px">
                  <IconButton
                    size="small"
                    disabled={disable}
                    onClick={() => {
                      onChange(null);
                    }}
                  >
                    <Trash03Icon
                      fontSize="small"
                      color={disable ? "disabled" : "primary"}
                    />
                  </IconButton>
                  <Typography
                    type="TextSM"
                    color={disable ? `${gray[300]}` : ""}
                  >
                    Remove
                  </Typography>
                </Box>
              ) : null}
            </Box>
          </Box>
        </Box>
      ) : null}

      {!isViewForm && !value ? (
        <Button
          component="label"
          variant="text"
          sx={{
            width: "100%",
            paddingX: "0px",
            paddingY: "0px",
            paddingBottom: "6px",
            height: "130px",
          }}
          disabled={disable}
        >
          <Box
            display="inline-block"
            borderRadius="12px"
            border={`1px solid ${primary[300]}`}
            textAlign="center"
            sx={{
              background: base.White,
              cursor: "pointer",
              "&:hover": {
                opacity: 0.7,
              },
              position: "absolute",
              width: "100%",
            }}
            height="130px"
          >
            <FileUploader
              handleChange={(file: File) => {
                handleUploadFile(file);
              }}
              name="file"
              types={fileType}
              sx={{ width: 300 }}
            >
              <>
                <Box
                  display="inline-flex"
                  marginBottom="12px"
                  marginTop="12px"
                  borderRadius="8px"
                  border={`1px solid ${gray[300]}`}
                  boxShadow={shadows.xs}
                  sx={{ background: base.White }}
                  padding="8px"
                >
                  <UploadCloud02Icon
                    sx={{ color: gray[600] }}
                    fontSize="small"
                  />
                </Box>
                <Typography type="TextSM" color={gray[600]} textAlign="center">
                  <span style={{ color: primary[700], fontWeight: 600 }}>
                    Click to upload
                  </span>
                  &nbsp;or drag and drop
                </Typography>
                {/* <Typography type="TextXS" color={gray[600]} textAlign="center">
                {
                  fileType?.join(", ") //eslint-disable-line
                }
              </Typography> */}
                <Typography type="TextSM" color={gray[600]} textAlign="center">
                  PDF(file size maximum 10MB)
                </Typography>
              </>
            </FileUploader>
          </Box>
        </Button>
      ) : null}
    </>
  );
};

const UploadFileV2HookForm = <
  TFieldValues extends FieldValues = FieldValues,
  TName extends FieldPath<TFieldValues> = FieldPath<TFieldValues>
>({
  name,
  defaultValue,
  rules,
  shouldUnregister,
  fileType,
  isViewForm,
  setPropsWithFormState,
  ...innerProps
}: TextFieldHookFormProps<TFieldValues, TName> & {
  fileType: string[];
  isViewForm?: boolean;
}) => {
  const { control } = useFormContext<TFieldValues>();
  return (
    <Controller
      name={name}
      defaultValue={defaultValue}
      rules={rules}
      shouldUnregister={shouldUnregister}
      control={control}
      render={(formState) => {
        const {
          field: { disabled, ref, onChange, value, ...innerField },
          formState: { errors },
        } = formState;
        const error = get(errors, name);
        const errorMsg = error?.message;
        const helperText =
          typeof errorMsg === "string" ? errorMsg : innerProps?.helperText;
        return (
          <FormControlLabel
            control={
              <Control
                onChange={onChange}
                value={value}
                disable={innerProps.disabled}
                fileType={fileType}
                isViewForm={isViewForm}
              />
            }
            error
            helperText={helperText}
            label={innerProps?.label}
            required={innerProps.required}
          />
        );
      }}
    />
  );
};

export default UploadFileV2HookForm;
